import React, { createContext, useContext, ReactNode } from 'react';

interface AuthContextType {
    userRole: string | null;
    userProfile: any | null;
}

const AuthContext = createContext<AuthContextType>({
    userRole: null,
    userProfile: null,
});

export const useAuth = () => useContext(AuthContext);

interface AuthProviderProps {
    children: ReactNode;
    userRole: string | null;
    userProfile: any | null;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children, userRole, userProfile }) => {
    return (
        <AuthContext.Provider value={{ userRole, userProfile }}>
            {children}
        </AuthContext.Provider>
    );
};
